/**
 * Segments d'URL par langue. Le **slug d'une entité ne change jamais** d'une
 * langue à l'autre (section 4.2, slugs stables) : seule la rubrique est
 * traduite. `/fr/artistes/elsa-vanderhoeven/` et
 * `/en/artists/elsa-vanderhoeven/` désignent la même fiche, ce qui rend la
 * réciprocité des `hreflang` mécanique.
 */
export const SEGMENTS = {
    fr: {
        accueil: '',
        artistes: 'artistes',
        expositions: 'expositions',
        foires: 'foires',
        oeuvres: 'oeuvres',
        actualites: 'actualites',
        'la-galerie': 'la-galerie',
        contact: 'contact',
        mentions: 'mentions-legales',
        confidentialite: 'confidentialite',
        'plan-du-site': 'plan-du-site',
    },
    en: {
        accueil: '',
        artistes: 'artists',
        expositions: 'exhibitions',
        foires: 'fairs',
        oeuvres: 'works',
        actualites: 'news',
        'la-galerie': 'the-gallery',
        contact: 'contact',
        mentions: 'legal-notice',
        confidentialite: 'privacy',
        'plan-du-site': 'sitemap',
    },
};
/** Chemin d'une rubrique : `/fr/expositions/`, `/en/`. */
export function cheminRubrique(langue, rubrique) {
    const segment = SEGMENTS[langue][rubrique];
    return segment === '' ? `/${langue}/` : `/${langue}/${segment}/`;
}
/** Chemin d'une fiche : `/fr/artistes/<slug>/`. */
export function cheminFiche(langue, rubrique, slug) {
    return `${cheminRubrique(langue, rubrique)}${slug}/`;
}
/** Chemin du flux RSS d'une langue. */
export function cheminFlux(langue) {
    return `/${langue}/feed.xml`;
}
/** Fichier écrit sur le disque pour un chemin de page. */
export function fichierDeChemin(chemin) {
    const nu = chemin.replace(/^\/+/, '');
    return nu === '' ? 'index.html' : `${nu}index.html`;
}
/** URL absolue, pour le canonical, les `hreflang`, Open Graph et le sitemap. */
export function urlAbsolue(domaine, chemin) {
    return `https://${domaine}${chemin}`;
}
/**
 * Chemin équivalent dans une autre langue. Le slug est conservé tel quel,
 * seule la rubrique est retraduite : c'est ce qui rend les `hreflang`
 * réciproques par construction.
 */
export function cheminTraduit(rubrique, slug, langue) {
    return slug === undefined
        ? cheminRubrique(langue, rubrique)
        : cheminFiche(langue, rubrique, slug);
}
//# sourceMappingURL=chemins.js.map